import React from 'react'
import { Grid, Stack, TextField } from '@mui/material'
import { format } from 'date-fns'
import { localeDateFormat } from '../../utils/localeUtils'
import { RequestDayRequest } from '../../types/requests'

interface RequestDaysDisplayProps {
  requestDays: RequestDayRequest[];
  isChangeRequested: () => boolean;
  getRequestDayCrHours: (requestDayId: number) => string | 0 | undefined;
}

function ChangedRequestDays({
  requestDays,
  isChangeRequested,
  getRequestDayCrHours,
  }: RequestDaysDisplayProps) {
    return (
      <Grid container gap={3}>
        {requestDays.map(day => (
          <Grid item xs={12} key={day.requestDayId}>
            <Stack direction="row" gap={2}>
              <TextField
                type="number"
                label={`Approved ${format(new Date(day.day), `ccc ${localeDateFormat}`)}`}
                defaultValue={day.hours}
                value={day.hours}
                disabled={isChangeRequested()}
                onWheel={event =>
                  event.target instanceof HTMLElement && event.target.blur()
                }
              />
              <TextField
                type="number"
                label={`Requested ${format(new Date(day.day), `ccc ${localeDateFormat}`)}`}
                defaultValue={getRequestDayCrHours(day.requestDayId)}
                value={getRequestDayCrHours(day.requestDayId)}
                disabled={isChangeRequested()}
                onWheel={event =>
                  event.target instanceof HTMLElement && event.target.blur()
                }
              />
            </Stack>
          </Grid>
        ))}
      </Grid>
    )
}

export default ChangedRequestDays